/**
 * Fire-and-forget confetti celebration (2026-07 bundle-reduction follow-up).
 *
 * canvas-confetti (~10 kB raw) only ever runs on a perfect-score submit, so it
 * has no business in the eager bundle of the assessment screens (one of which,
 * /assessment, is an LCP target). Dynamically importing it here keeps it in its
 * own tiny chunk, fetched the first time a student aces an assessment. The
 * celebration is non-essential, so any load/animation failure is swallowed.
 */
export function fireConfetti(options) {
  import('canvas-confetti')
    .then(({ default: confetti }) => confetti(options))
    .catch(() => {});
}
